import { NetworkLogsStateType } from './state'

export interface NetworkLogsGettersType {
  getNetworkLogsById: (state: NetworkLogsStateType, id: string) => NetworkLogsStateType['networkLog']
  getNetworkLogsBySourceId: (state: NetworkLogsStateType, sourceId: string) => NetworkLogsStateType['networkLogs']
  getNetworkLogsBySourceType: (state: NetworkLogsStateType, sourceType: string) => NetworkLogsStateType['networkLogs']
  getNetworkLogsByStatus: (state: NetworkLogsStateType, status: string) => NetworkLogsStateType['networkLogs']
  getNetworkLogsByOperation: (state: NetworkLogsStateType, operation: string) => NetworkLogsStateType['networkLogs']
}

export const NetworkLogsGetters = {
  getNetworkLogsById: (state: NetworkLogsStateType) => (id: string) => {
    return state.networkLogs.find(networkLog => networkLog.id === id)
  },
  getNetworkLogsBySourceId: (state: NetworkLogsStateType) => (sourceId: string) => {
    return state.networkLogs.filter(networkLog => networkLog.sourceId === sourceId)
  },
  getNetworkLogsBySourceType: (state: NetworkLogsStateType) => (sourceType: string) => {
    return state.networkLogs.filter(networkLog => networkLog.sourceType === sourceType)
  },
  getNetworkLogsByStatus: (state: NetworkLogsStateType) => (status: string) => {
    return state.networkLogs.filter(networkLog => networkLog.status === status)
  },
  getNetworkLogsByOperation: (state: NetworkLogsStateType) => (operation: string) => {
    return state.networkLogs.filter(networkLog => networkLog.operation === operation)
  },
}
